// extracted by mini-css-extract-plugin
export default {"main":"Reservations_main__bnsF1","box":"Reservations_box__uZ3Ew","email":"Reservations_email__JGTdn"};